<template>
  <el-row
    :mb="15"
    :gutter="15"
  >
    <el-col :gutter="15">
      <el-row>
        <el-col>
          <Header
            v-if="consignment"
            :enquiry="enquiry"
            :consignment="consignment"
          />
        </el-col>
      </el-row>
      <br>
      <el-row>
        <el-card>
          <Details :enquiry="enquiry" />
        </el-card>
      </el-row>
      <br>
      <el-row :gutter="15">
        <el-col :md="18">
          <el-card>
            <Conversation :enquiry="enquiry" />
          </el-card>
        </el-col>
        <el-col :md="6">
          <el-card>
            <Fields :enquiry="enquiry" />
          </el-card>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>
<script>
import Details from './Enquiry/Details'
import Conversation from './Enquiry/Conversation'
import Fields from './Enquiry/Fields'
import Header from './Enquiry/Header'

export default {
  components: {
    Details,
    Conversation,
    Fields,
    Header
  },
  props: {
    enquiry: {
      type: Object,
      required: true
    },
    consignment: {
      type: Object,
      required: false,
      default: null
    }
  }
}
</script>
